import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19z"
}), 'FlightTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FlightTwoTone.js
// module id = 3743
// module chunks = 2